import { createAction } from '@reduxjs/toolkit';
import { SIMILAR_PACKAGES_GO_TO_HOTEL } from '../constants/similar-packages';

export {
  similarPackagesFail,
  similarPackagesStart as similarPackagesStartAction,
  similarPackagesCreatedRequest as similarPackagesCreatedRequestAction,
  similarPackagesFinish as similarPackagesFinishAction,
  similarPackagesPopupOpened as similarPackagesPopupOpenedAction,
  similarPackagesPopupClosed as similarPackagesPopupClosedAction,
  createPackageAction,
  createPackageFail,
  clearSearch as clearSearchAction,
  setSearcherDate as setSearcherDateAction,
  setAdults as setAdultsAction,
  setKids as setKidsAction,
  setNights as setNightsAction,
} from '../reducers/similar-packages';

export const similarPackagesGoToHotelAction = createAction(
  SIMILAR_PACKAGES_GO_TO_HOTEL,
);
